// ink-component
import React from 'react';

export interface DisplayProps {
  /** When should the component be rendered */
  when?: any;
  /** Content to be rendered  */
  children?: any;
}

/**
 * @purpose Renders content conditionally
 * @categories accessory
 * @status sunset
 */
function Display(props: DisplayProps) {
  const { when, children } = props;

  if (when) {
    return typeof children === 'function' ? <>{children()}</> : <>{children}</>;
  }

  return null;
}

Display.defaultProps = {
  when: false,
  children: undefined,
};

Display.displayName = 'Display';

export default Display;
